import { abUseExperimentsSelector } from 'shared/selectors';
import { IState } from 'shared/store';

export type TSelectCPDTrapGroup = 'control' | 'test';

export const CPD_TRAP_EXPERIMENT_NAME = 'b2b_pa16510_replacement_mortgage_banner_on_adcard_with_cpd_web';

export const selectCPDTrapGroup = (state: IState): TSelectCPDTrapGroup => {
  const experiments = abUseExperimentsSelector(state);
  const experiment = experiments.find(o => o.experimentName === CPD_TRAP_EXPERIMENT_NAME);

  return (experiment?.groupName || 'control') as TSelectCPDTrapGroup;
};
